document.addEventListener('DOMContentLoaded', function(){

    document.querySelectorAll('.editor').forEach(editor => {
        editor.querySelectorAll('iframe').forEach(iframe => {
            iframe.outerHTML = `<div class="ratio ratio-16x9 mb-3">${iframe.outerHTML}</div>`;
        });
    });

});